import { quoteCount } from '@/atoms/stats'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Event } from '@nostr/tools/wasm'
import { HugeiconsIcon } from '@hugeicons/react'
import { QuillWrite02Icon } from '@hugeicons/core-free-icons'
import { cn } from '@/lib/utils'
import { getNoteBech32Id } from '@/lib/event'
import { canWriteAtom } from '@/atoms/session'
import { useAtomValue } from 'jotai'
import PostEditor from '../PostEditor'
import { formatCount } from './utils'

export default function QuoteButton({ event }: { event: Event }) {
  const { t } = useTranslation()
  const count = useAtomValue(quoteCount(event.id))
  const [isPostDialogOpen, setIsPostDialogOpen] = useState(false)
  const canWrite = useAtomValue(canWriteAtom)

  return (
    <>
      <button
        className={cn(
          'flex gap-1 items-center text-muted-foreground enabled:hover:text-lime-500 disabled:opacity-50 disabled:cursor-not-allowed px-3 h-full'
        )}
        title={t('Quote')}
        disabled={!canWrite}
        onClick={(e) => {
          e.stopPropagation()
          setIsPostDialogOpen(true)
        }}
      >
        <HugeiconsIcon icon={QuillWrite02Icon} />
        {!!count && <div className="text-sm">{formatCount(count)}</div>}
      </button>
      <PostEditor
        open={isPostDialogOpen}
        setOpen={setIsPostDialogOpen}
        defaultContent={'\nnostr:' + getNoteBech32Id(event)}
      />
    </>
  )
}
